import React, { Component } from "react";

import AsyncSelect from 'react-select/lib/Async';
// // import { Button } from "react-bootstrap";
import { Button } from 'reactstrap';
import "./signUp.css";
import { Redirect } from 'react-router';
import background from '../../images/background.svg';
import logo from '../../images/logo.svg';
import authStore from '../../../stores/auth-store';
import queryString from 'query-string'
import jumpersStore from "../../../stores/jumpers-store";
import swal from 'sweetalert';

const customStyles = {
      container :(provided) =>({
        ...provided,
        minHeight:48,
        height:'100%',
        width:'100%'
      }),
    control: (provided) => ({
        ...provided,
        minHeight:48,
        height:'100%',
    }),
    singleValue: (provided, state) => {
      return { ...provided };
    }
  }

export default class SignUp extends Component {
    constructor(props) {
        super(props);

        this.state = {
            username: "",
            password: "",
            email:'',
            invalid: false,
            inputValue: '' ,
            jumpersDetails:[],
            defaultOptions:[],
            selectedJumper:{},
            loading: false,
            jumperLoading:true
        };
    }

	getJumperOptions = (array) => {
		var jumperOptions = array.map(jumper => {
			var label = jumper.nickname;
			if (jumper.lastname) {
				label += " " + jumper.lastname;
			}
			if (jumper.manifestNumber) {
				label += " " + jumper.manifestNumber;
			}
			return { "label": label, "value": jumper }
		});

		return jumperOptions;
    }
    
    componentDidMount () {
        jumpersStore.getAllJumpers()
        .then(data => {
            if (data) {
                let newArray = this.getJumperOptions(data.jumpers)
                let defaultOptions = newArray.slice(0, 20);
                this.setState({ jumpersDetails : newArray, defaultOptions , jumperLoading : false})
            }
        });
    }

    handleInputChange = (newValue) => {
        const inputValue = newValue.replace(/\W/g, '');
        this.setState({ inputValue });
        return inputValue;
    };

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value,
            invalid: false
        });
    }

    filterJumpers = (inputValue, jumperOptions) => {
        let filteredOptions =  []
		if (inputValue) {
            filteredOptions = jumperOptions.filter(val => {
                let str = val.label.toUpperCase()
                return str.includes(inputValue.toUpperCase())
            })
			if (filteredOptions.length > 30) return filteredOptions = filteredOptions.slice(0, 30);
			else return filteredOptions;
		}
	};

	promiseOptions = (inputValue) => {
        let { jumpersDetails } = this.state
		return new Promise(resolve => {
			resolve(this.filterJumpers(inputValue, jumpersDetails));
		});
    }
    
    handleSelect = (val) => {
        console.log(val)
        this.setState({ selectedJumper : val })
    }
    
    handleSubmit = event => {
        event.preventDefault();
        let { username , email, password, selectedJumper } = this.state
        if (username && email && password && Object.keys(selectedJumper).length) {
            this.setState({ loading : true })
        let signUpValues = {
            username: username, 
            password: password,
            email : email,
            selectedJumperId : selectedJumper.value._id,
            role:'jumper'
        }
        authStore.signUp(signUpValues)
            .then(res => {
                console.log(res,"resss");
                if (res && res.data && res.status == 200) {
                    swal({
                        title: "Success",
                        text: "Registered sucessfully please check email to verify",
                        icon: "success",
                        dangerMode: false,
                    })
                    this.setState({
                        loading : false,
                        username: "",
                        password: "",
                        email:'',
                        invalid: false,
                        inputValue: '' 
                    })
                }
                else {
                    this.setState({ loading : false })
                    if (res && res.msg) {
                        this.setState({ invalid: res.msg });
                    } else if( res && res.err && res.err.message) {
                        this.setState({ invalid: res.err.message });
                    }else{
                        this.setState({ invalid: "Some thing went wrong" });
                    }
                    setTimeout(() => {
                        this.setState({ invalid: false });
                    }, 3000);
                }
            })
        } else {
            this.setState({ invalid: 'Please fill all the fields', loading : false });
                setTimeout(() => {
                    this.setState({ invalid: false });
                }, 3000);
        }
     
    }

    render() {
        let { invalid,jumperLoading, defaultOptions, loading } = this.state
        // console.log(defaultOptions,"defaultOptions defaultOptions")
        return (
            <div className="row" style={{ backgroundImage: `url(${background})`, minHeight: '100vh', backgroundSize: 'cover', width: '100%', margin: '0px', overflow: 'hidden' }}>
                <div className="col-md-12">
                    <div className="signUP">
                        <form onSubmit={this.handleSubmit}>
                            <img src={logo} alt="logo" />
                            {
                                invalid ?
                                    <label style={{ color: 'red', marginBottom: '12px' }}>{invalid}</label>
                                    : ''
                            }
                            <div className="input-container search-field">
                                <i className="fa fa-search icon"></i>
                                <AsyncSelect
                                     styles={customStyles}
                                    cacheOptions
                                    defaultOptions={defaultOptions}
                                    loadOptions={(newValue) => this.promiseOptions(newValue)}
                                    onChange={(val) => this.handleSelect(val)}
                                    onInputChange={this.handleInputChange}
                                    placeholder={jumperLoading ? "Loading Jumpers please wait ..." : "Select Jumper"}
                                    />
                            </div>
                            <div className="input-container">
                                <i className="fa fa-user icon"></i>
                                <input className="input-field" type="text"              placeholder="Enter Username"
                                    id="username"
                                    value={this.state.username}
                                    onChange={this.handleChange} />
                            </div>
                            <div className="input-container">
                                <i className="fa fa-key icon"></i>
                                <input
                                    className="input-field"
                                    type="password"
                                    placeholder="Enter Password"
                                    id="password"
                                    value={this.state.password}
                                    onChange={this.handleChange}
                                    type="password" />
                            </div>

                            <div className="input-container">
                                <i className="fa fa-envelope icon"></i>
                                <input className="input-field" type="email" placeholder="Enter Email"
                                    id="email"
                                    value={this.state.email}
                                    onChange={this.handleChange}
                                    type="email" />
                            </div>

                            <Button
                                disabled={loading}
                                block
                                bsSize="large"
                                type="submit"
                                className="lightBlueButton btn btn-lg btn-default btn-block"
                            >
                             {  loading ? "Loading..."  : 'Sign Up'}
                            </Button>
                            <div onClick={() =>  this.props.history.push('/login')} className="textRightLink">
                                Already have an account? Click to Sign in
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}